const style = (theme) => {
  const output = {
    root: {
      extend: theme.smallWrapper,
      overflow: 'hidden',
    },
    list: {
      display: 'flex',
      justifyContent: 'space-between',
      touchAction: 'pan-y',
      '& > *': {
        width: '25%',
      },
    },
    item: {
      flex: '0 0 200px',
      width: 200,
      height: 200,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 24,
      color: theme.colors[1],
      textTransform: 'uppercase',
      fontWeight: 300,
      fontFamily: theme.fonts[1],
      background: theme.colors[4],
    },
    itemEven: {
      marginTop: 100,
      background: theme.colors[3],
    },

    controls: {
      extend: theme.smallWrapper,
      display: 'none',
      flexDirection: 'column',
      marginTop: 20,
    },
    scrollbar: {
      width: '100%',
      height: 1,
      background: theme.getRgba(theme.colors[4], 0.15),
      display: 'flex',
      marginTop: 50,
    },
    scrollThumbPre: {
      background: theme.colors[4],
    },
    scrollthumb: {
      flex: '1 0 auto',
      background: theme.colors[4],
      transform: 'scaleX(var(--progress))',
      transformOrigin: '0 0',
    },

    isDragging: {
      '& *': {
        cursor: 'grabbing',
      },
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    list: {
      paddingLeft: 'calc(50vw - 100px)',
      paddingRight: 30,
      overflow: 'visible',
      display: 'inline-flex',
      marginLeft: -25,
      marginRight: -25,
      '& > *': {
        '&:not(:last-child)': {
          marginBottom: 25,
        },
      },
    },
    controls: {
      display: 'flex',
    },
  }

  return output
}

export default style
